// src/components/directorProfile/StepDirectorAddress.jsx
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import FormInput from '../../form/FormInput';

const StepDirectorAddress = ({ control, errors,setValue, handlePincodeLookup }) => (
    <div className="animate-fade-in">
        <div className="form-section-title">Address</div>
        <Row>
            <Controller name="addressType" control={control} render={({ field }) => <input type="hidden" {...field} />} />
            <Col md={4}><FormInput name="addressLine1" label="Address Line 1" control={control} errors={errors} isRequired /></Col>
            <Col md={4}><FormInput name="state" label="State" control={control} errors={errors} isRequired /></Col>
            <Col md={4}><FormInput name="district" label="District" control={control} errors={errors} isRequired /></Col>
            
            <Col md={4}>
                <FormInput 
                    name="pinCode" 
                    label="Pin Code" 
                    control={control} 
                    errors={errors} 
                    isRequired 
                    maxLength={6}
                    customOnChange={(e) => {
                        const value = e.target.value;
                        setValue('pinCode', value, { shouldValidate: true });
                        if (value.length === 6) handlePincodeLookup(value);
                    }}
                />
            </Col>
        </Row>
        <Row>
            <Col md={6}><FormInput name="addressLine2" label="Address Line 2" control={control} errors={errors} hidden /></Col>
        </Row>
    </div>
);

export default StepDirectorAddress;